import React from 'react'
import HeroSection from "app/components/homepage/HeroSection"
import AboutUs from "app/components/homepage/AboutUs"
import HelmetTitle from "app/meta/HelmetTitle"
import Services from "app/components/homepage/Services"
import OurTeam from "app/components/homepage/OurTeam"
import MakeAppointment from "app/components/homepage/MakeAppointment"
import './styles/Homepage.css'
import Subscribe from "app/components/homepage/Subscribe"
import Contact from "app/components/homepage/Contact"

export default function HomePage() {

  return (
    <div className="homepage">
      <HelmetTitle title="Home"/>
      <HeroSection />
      <AboutUs />
      <Services />
      <OurTeam />
      <MakeAppointment className="home-section"/>
      <Subscribe />
      <Contact />
    </div>
  )
}
